import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        course: '=',
        fields: '=',
        sites: '=',
        certificates: '='
    },
    template: `
        <courses-courses-steps-add
            course="vm.course"
            fields="vm.fields"
            context="vm.context"
            sites="vm.sites"
            certificates="vm.certificates"
        />`
})

export default class {
    constructor () {
        this.context = 'add';
    }
}



// WEBPACK FOOTER //
// ./src/app/components/courses/courses/add/general/index.js